import type { ValueProp } from '../../product.types';

export type ValuePropGroup = Readonly<{ highlight: boolean; valueProps: ReadonlyArray<ValueProp> }>;

export const valuePropLabel = (prop: ValueProp): string => (typeof prop === 'string' ? prop : prop.label);

export const isHighlightedValueProp = (prop: ValueProp): boolean => typeof prop !== 'string' && !!prop.highlight;

/** Splits value props into runs, so consecutive highlighted rows share one tinted group. */
export const groupValueProps = (valueProps: ReadonlyArray<ValueProp>): ReadonlyArray<ValuePropGroup> => {
  const groups: Array<{ highlight: boolean; valueProps: ValueProp[] }> = [];
  for (const prop of valueProps) {
    const highlight = isHighlightedValueProp(prop);
    const lastGroup = groups[groups.length - 1];
    if (lastGroup && lastGroup.highlight === highlight) {
      lastGroup.valueProps.push(prop);
    } else {
      groups.push({ highlight, valueProps: [prop] });
    }
  }
  return groups;
};
